<template>
  <div class="page-title mt-3">
    <label class="title-box col-1 pr-5">{{ "'" }}</label
    ><strong class="ml-5 page-title">{{ $t("basicInformation") }}</strong>
  </div>
  <div class="mx-5 mt-3">
    <div style="text-align: left">
      <!--姓名-->
      <div class="m-3" ref="namehight">
        <div>
          {{ "1."
          }}<label class="formtext-title">{{ $t("name") }}{{ "*" }}</label>
        </div>
        <div v-if="checkNameBox === true" class="form-error-box">
          <label class="form-error-text">{{ NameText }}</label>
        </div>
        <label v-else class="form-magin">{{ "1" }}</label>
        <input
          type="text"
          class="input-bottom-line"
          :placeholder="$t('_pleaseEnter')"
          v-model.trim="userName"
        />
      </div>
      <!--公司-->
      <div class="m-3" ref="companyhight">
        <div>
          {{ "2."
          }}<label class="formtext-title">{{ $t("company") }}{{ "*" }}</label>
        </div>
        <div v-if="checkCompany === true" class="form-error-box">
          <label class="form-error-text">{{ CompanyText }}</label>
        </div>
        <label v-else class="form-magin">{{ "1" }}</label>
        <input
          type="text"
          class="input-bottom-line"
          :placeholder="$t('_fullName')"
          v-model.trim="userCompany"
        />
      </div>
      <!--部門-->
      <div class="m-3">
        <div>
          {{ "3." }}<label class="formtext-title">{{ $t("department") }}</label>
        </div>
        <label class="form-magin">{{ "1" }}</label>
        <input
          type="text"
          class="input-bottom-line"
          :placeholder="$t('_pleaseEnter')"
          v-model.trim="department"
        />
      </div>
      <!--職稱-->
      <div class="m-3" ref="positionhight">
        <div>
          {{ "4."
          }}<label class="formtext-title"
            >{{ $t("positionTitle") }}{{ "*" }}</label
          >
        </div>
        <div v-if="checkPosition === true" class="form-error-box">
          <label class="form-error-text">{{ positionText }}</label>
        </div>
        <label v-else class="form-magin">{{ "1" }}</label>
        <input
          type="text"
          class="input-bottom-line"
          :placeholder="$t('_pleaseEnter')"
          v-model.trim="positionTitle"
        />
      </div>
      <!--公司電話-->
      <div class="m-3" ref="comtelhight">
        <div>
          {{ "5."
          }}<label class="formtext-title"
            >{{ $t("companyPhone") }}{{ "*" }}</label
          >
        </div>
        <div v-if="checkCompanyTel === true" class="form-error-box">
          <label class="form-error-text">{{ companyTelText }}</label>
        </div>
        <label v-else class="form-magin">{{ "1" }}</label>
        <input
          type="tel"
          class="input-bottom-line"
          :placeholder="$t('_phoneHint')"
          v-model.trim="companyPhone"
        />
      </div>
      <!--手機-->
      <div class="m-3" ref="phonehight">
        <div>
          {{ "6."
          }}<label class="formtext-title"
            >{{ $t("phoneNumber") }}{{ "*" }}</label
          >
        </div>
        <div v-if="checkPhone === true" class="form-error-box">
          <label class="form-error-text">{{ phoneText }}</label>
        </div>
        <label v-else class="form-hint">{{ $t('phoneHint') }}</label>
        <input
          type="tel"
          class="input-bottom-line"
          :placeholder="$t('_pleaseEnter')"
          v-model.trim="phoneNumber"
        />
      </div>
      <!--信箱-->
      <div class="m-3" ref="emailhight">
        <div>
          {{ "7."
          }}<label class="formtext-title">{{ $t("email") }}{{ "*" }}</label>
        </div>
        <div v-if="checkEmail === true" class="form-error-box">
          <label class="form-error-text">{{ emailText }}</label>
        </div>
        <label v-else class="form-magin">{{ "1" }}</label>
        <input
          type="email"
          class="input-bottom-line"
          :placeholder="$t('_pleaseEnter')"
          v-model.trim="email"
        />
      </div>
      <!--聯絡時間-->
      <div class="m-3">
        <div>
          {{ "8."
          }}<label class="formtext-title">{{
            $t("convenientContactTime")
          }}</label>
        </div>
        <label class="form-hint">{{ $t('_contactTime') }}</label>
        <select class="col-12" v-model="time">
          <option value="none" disabled>{{ $t("_pleaseChoose") }}</option>
          <option value="a">{{ "08-10" }}</option>
          <option value="b">{{ "10-12" }}</option>
          <option value="c">{{ "13-15" }}</option>
          <option value="d">{{ "15-17" }}</option>
          <option value="e">{{ $t("allAreAcceptable") }}</option>
        </select>
      </div>
      <div>
        <button class="offset-5 mt-5 col-lg-2 btn" @click="submitMemberData">
          {{ $t("nextPage") }}
        </button>
      </div>
    </div>
  </div>
</template>
<style scoped>
input:focus {
  box-shadow: 0 0 0 0;
  outline-offset: 0px;
  outline: none;
  border-bottom: 0.1rem solid rab(127, 150, 182);
}
</style>
<script setup>
import { ref, watch, onMounted, defineEmits } from "vue";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const formData = ref({
  name: "",
  company: "",
  department: "",
  positionTitle: "",
  companyPhone: "",
  phoneNumber: "",
  email: "",
  time: "",
});
/**回傳父層 */
const emit = defineEmits({
  formData: Array,
  count: Number,
  changePage: Boolean,
});
/**欄位位置 */
const namehight = ref(0);
const companyhight = ref(0);
const positionhight = ref(0);
const comtelhight = ref(0);
const phonehight = ref(0);
const emailhight = ref(0);
const qustion1 = ref(0); //名字
const qustion2 = ref(0); //公司
const qustion4 = ref(0); //職稱
const qustion5 = ref(0); //公司電話
const qustion6 = ref(0); //手機
const qustion7 = ref(0); //信箱
/**取得元素高度 */
onMounted(() => {
  qustion1.value = namehight.value.offsetTop;
  qustion2.value = companyhight.value.offsetTop;
  qustion4.value = positionhight.value.offsetTop;
  qustion5.value = comtelhight.value.offsetTop;
  qustion6.value = phonehight.value.offsetTop;
  qustion7.value = emailhight.value.offsetTop;
});
/**位置判斷 */
const toTop = (top) => {
  document.body.scrollTop = top;
  document.documentElement.scrollTop = top;
};
/**欄位 */
const userName = ref("");
const userCompany = ref("");
const department = ref("");
const positionTitle = ref("");
const companyPhone = ref("");
const phoneNumber = ref("");
const email = ref("");
const time = ref("none");
/**錯誤提示欄位 */
const checkNameBox = ref(false);
const NameText = ref("");

const checkCompany = ref(false);
const CompanyText = ref("");

const checkPosition = ref(false);
const positionText = ref("");

const checkCompanyTel = ref(false);
const companyTelText = ref("");

const checkPhone = ref(false);
const phoneText = ref();

const checkEmail = ref(false);
const emailText = ref("");

/**驗證 */
const isText = /[/@/#/%/^/*/=/+/!/`/,/'/;/:/?/$/~]/;
//const inclde = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{4,20}$/;
const isEmail = /[/,/;/:/'/"/]/;
const isTel=/(\d{2,3}-?|\(\d{2,3}\))\d{3,4}-?\d{4}|09\d{2}(\d{6}|-\d{3}-\d{3})/;
const isPhone=/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-0-9]*$/;
const count = ref(0);
watch(
  [
    userName,
    userCompany,
    department,
    positionTitle,
    companyPhone,
    phoneNumber,
    email,
    time,
  ],
  ([
    newName,
    newcompany,
    newdepart,
    newpoaition,
    newcompanytel,
    newphone,
    newemail,
    newtime,
  ]) => {
    dataCheck(
      newName,
      newcompany,
      newdepart,
      newpoaition,
      newcompanytel,
      newphone,
      newemail,
      newtime
    );
  }
);
/**檢查資料 */
const dataCheck = (
  newName,
  newcompany,
  newdepart,
  newpoaition,
  newcompanytel,
  newphone,
  newemail,
  newtime
) => {
  count.value = 0;
  let error = ref(false);
  formData.value.time = "";
  formData.value.department = "";
  /**name */
  if (isText.test(newName) && newName.length !== 0) {
    checkNameBox.value = true;
    NameText.value = t("specialSymbols") + "*/&#@$,!?`~";
    formData.value.name = "";
    error.value = true;
  } else if (newName.length > 15) {
    checkNameBox.value = true;
    NameText.value = t("nameNumberlimit");
    formData.value.name = "";
    error.value = true;
  } 
  else if (newName.length < 3&&newName.length!==0) {
    checkNameBox.value = true;
    NameText.value = t("nameNumberover3");
    formData.value.name = "";
    error.value = true;
  } else {
    if (newName !== "") {
      count.value++;
    }
    checkNameBox.value = false;
    NameText.value = "";
    formData.value.name = newName;
  }
  /**company */
  if (isText.test(newcompany) && newcompany.length !== 0) {
    checkCompany.value = true;
    CompanyText.value = t("specialSymbols") + "*/&#@$,!?`~";
    formData.value.company = "";
    error.value = true;
  } else if (newcompany.length > 15) {
    checkCompany.value = true;
    CompanyText.value = t("nameNumberlimit");
    formData.value.company = "";
    error.value = true;
  } else {
    if (newcompany !== "") {
      count.value++;
    }
    checkCompany.value = false;
    CompanyText.value = "";
    formData.value.company = newcompany;
  }
  /**position */
  if (isText.test(newpoaition) && newpoaition.length !== 0) {
    checkPosition.value = true;
    positionText.value = t("specialSymbols") + "*/&#@$,!?`~";
    formData.value.positionTitle = "";
    error.value = true;
  } else if (newpoaition.length > 15) {
    checkPosition.value = true;
    positionText.value = t("nameNumberlimit");
    formData.value.positionTitle = "";
    error.value = true;
  } else {
    if (newpoaition !== "") {
      count.value++;
    }
    checkPosition.value = false;
    positionText.value = "";
    formData.value.positionTitle = newpoaition;
  }
  /**公司電話 */
  if (!isTel.test(newcompanytel) && newcompanytel!=='') {
    checkCompanyTel.value = true;
    companyTelText.value = t("IncorrectFormat");
    formData.value.companyPhone = "";
    error.value = true;
  } else if (newcompanytel.length > 20||(newcompanytel.length<9&&newcompanytel!=='')) {
    checkCompanyTel.value = true;
    companyTelText.value = t("phoneCount");
    formData.value.companyPhone = "";
    error.value = true;
  } else {
    if (newcompanytel !== "") {
      count.value++;
    }
    checkCompanyTel.value = false;
    companyTelText.value = "";
    formData.value.companyPhone = newcompanytel;
  }
  /**手機 */
  if (!isPhone.test(newphone) && newphone!=='') {
    checkPhone.value = true;
    phoneText.value = t("phoneCount");
    formData.value.phoneNumber = "";
    error.value = true;
  } else if (newphone.length > 20||(newphone.length<9&&newphone!=='')) {
    checkPhone.value = true;
    phoneText.value = t("phoneCount");
    formData.value.phoneNumber = "";
    error.value = true;
  } else {
    if (newphone !== "") {
      count.value++;
    }
    checkPhone.value = false;
    phoneText.value = "";
    formData.value.phoneNumber = newphone;
  }
  /**email */
  if (
    newemail.length !== 0 &&
    (newemail.indexOf("@") === -1 ||
      newemail.indexOf(".com") === -1 ||
      isEmail.test(newemail))
  ) {
    checkEmail.value = true;
    emailText.value = t("IncorrectFormat");
    formData.value.email = "";
    error.value = true;
  } else {
    if (newemail !== "") {
      count.value++;
    }
    checkEmail.value = false;
    emailText.value = "";
    formData.value.email = newemail;
  }
  if (newdepart !== "") {
    formData.value.department = newdepart;
  }
  if (newtime !== "") {
    formData.value.time = newtime;
  }
  if(count.value>0){
    emit("count", count.value);
  }else{
    emit("count", -1);
  }
  if (error.value === true) {
    return false;
  }
};
/**回傳 */
const rebackType = ref(false);
const submitMemberData = () => {
  dataCheck(
    formData.value.name,
    formData.value.company,
    formData.value.department,
    formData.value.positionTitle,
    formData.value.companyPhone,
    formData.value.phoneNumber,
    formData.value.email,
    formData.value.time
  );
  if (formData.value.name === "") {
    checkNameBox.value = true;
    NameText.value = t("name")+' ' + t("requiredFields");
    toTop(qustion1.value);
    return false;
  }
  if (formData.value.company === "") {
    checkCompany.value = true;
    CompanyText.value = t("company")+' ' + t("requiredFields");
    toTop(qustion2.value);
    return false;
  }
  if (formData.value.positionTitle === "") {
    checkPosition.value = true;
    positionText.value = t("positionTitle")+' ' + t("requiredFields");
    toTop(qustion4.value);
    return false;
  }
  if (formData.value.companyPhone === "") {
    checkCompanyTel.value = true;
    companyTelText.value = t("companyPhone")+' ' + t("requiredFields");
    toTop(qustion5.value);
    return false;
  }
  if (formData.value.phoneNumber === "") {
    checkPhone.value = true;
    phoneText.value = t("phoneNumber")+' ' + t("requiredFields");
    toTop(qustion6.value);
    return false;
  }
  if (formData.value.email === "") {
    checkEmail.value = true;
    emailText.value = t("email")+' ' + t("requiredFields");
    toTop(qustion7.value);
    return false;
  }
  //api
  rebackType.value = !rebackType.value;
  emit("formData", formData.value);
  emit("changePage", rebackType.value);
};
</script>
